<template>
  <b-col cols="12" sm="12">
    <div>
      <a class="btnVolver" @click="$router.push({ path: 'dispositivos' })" title="Cerrar">
        <feather id="btnX" type="arrow-left-circle"></feather>
      </a>
    </div>
    <div class="d-flex mt-2">
      <p style="font-weight: 500;">Tipo dispositivo:</p>
      <b-form-group v-slot="{ ariaDescribedby }">
        <b-form-radio-group class="inputRadioGroup" v-model="tipoDispositivo" :options="translateRadio"
          :aria-describedby="ariaDescribedby" name="radio-inline">
        </b-form-radio-group>
      </b-form-group>
    </div>

    <!--GPS COMERCIAL-->
    <b-card class="mx-auto" tile v-if="tipo">
      <span>*{{ $t('Gral.camposObligatorios') }}</span>
      <h5 class="text-center text-danger" v-if="estatusImei">
        El {{ this.limpiarTexto(txtImei) }} ya está registrado, ingrese otro por favor.
      </h5>
      <h5 class="text-center text-danger" v-if="estatusTelefono">
        El teléfono ya está registrado, ingrese otro por favor.
      </h5>

      <b-form @submit.stop.prevent="updateDispositivo" style="z-index: 1;">
        <b-col cols="12" sm="12">
          <div class="row">
            <b-col cols="12" sm="6">
              <label for="nombre">{{ $t('Gral.nombre') }}* :</label>
              <b-form-input class="form-input-border" id="nombre" v-model="dispositivo.nombre" required
                autocomplete="off">
              </b-form-input>
              <b-form-invalid-feedback id="nombre-invalid">
                {{ $t('vDispositivos.msgIngresarN') }}
              </b-form-invalid-feedback>
            </b-col>

            <b-col cols="12" sm="6">
              <label for="contrasena">{{ $t('vDispositivos.msgPass') }}* :</label>
              <b-form-input id="contrasena" v-model="dispositivo.contrasena" :state="passwordState" required
                autocomplete="off">
              </b-form-input>
              <b-form-invalid-feedback id="contrasena-invalid">
                {{ $t('vDispositivos.msgIngresePass') }}
              </b-form-invalid-feedback>
              <b-form-text id="input-live-help-password">
                {{ $t('vDispositivos.msgFormatPass') }}
              </b-form-text>
            </b-col>
          </div>

          <div class="row">
            <b-col cols="12" sm="6">
              <label for="modelo">{{ $t('Gral.modelo') }}* :</label>
              <multiselect id="pais" v-model="selectedModel" :options="gpsModelList" :multiple="false" track-by="id"
                label="modelo" :selectLabel="$t('vHistorico.presioneAgregar')" emptyLabel="No se encontraron elementos"
                :selectedLabel="$t('vHistorico.seleccionado')" :deselectLabel="$t('vHistorico.presioneEliminar')"
                :placeholder="$t('vDispositivos.msgSelecModelo')" @input="modeloSelected">
                <span slot="noResult">
                  {{ $t("vDispositivos.msgSelecModelo") }}
                </span>
              </multiselect>
            </b-col>

            <b-col cols="12" sm="6">
              <label for="imei">{{ txtImei }}</label>
              <b-form-input id="imei" v-model="dispositivo.imei" required :disabled="!isMaster"
                :state="(dispositivo.imei.length === 15 && txtImei.includes('IMEI')) || (dispositivo.imei.length === 10 && txtImei.includes('ID')) ? true : false"
                type="number" aria-describedby="input-live-help input-live-feedback-imei input-live-feedback-id"
                autocomplete="off" @input="contarDigitos" />
              <b-form-invalid-feedback v-if="txtImei.includes('IMEI') && dispositivo.imei.length !== 15"
                id="input-live-feedback-imei">
                El IMEI debe tener 15 caracteres
              </b-form-invalid-feedback>
              <b-form-invalid-feedback v-if="txtImei.includes('ID') && dispositivo.imei.length !== 10"
                id="input-live-feedback-id">
                El ID debe tener 10 caracteres
              </b-form-invalid-feedback>
              <b-form-text v-if="estatusImei" id="input-live-warning" style="color: red !important;">
                ¡Ingrese un {{ limpiarTexto(txtImei) }} diferente!
              </b-form-text>
            </b-col>


          </div>

          <div class="row">
            <b-col cols="12" sm="6">
              <label for="“nombre”">Seleccione el código de país* :</label>

              <multiselect id="paisTelefono" v-model="selectedPaisId" :options="countryOptions" :multiple="false"
                track-by="iso" label="label" :selectLabel="$t('vHistorico.presioneAgregar')"
                emptyLabel="No se encontraron elementos" :selectedLabel="$t('vHistorico.seleccionado')"
                :deselectLabel="$t('vHistorico.presioneEliminar')" @input="inputSelectPais"
                :placeholder="$t('vHistorico.mssgSelectCodigoPais')">
                <span slot="noResult">
                  {{ $t("vHistorico.msgBusquedaFallida") }}
                </span>
              </multiselect>

            </b-col>

            <!-- COUNTRY SELECT + PHONE INPUT -->
            <b-col cols="12" sm="6">
              <label for="telefono">{{ $t("Gral.tel") }}</label>
              <b-input-group>
                <b-input-group-prepend is-text>
                  {{ selectedDialCode }}
                </b-input-group-prepend>

                <b-form-input id="telefono" v-model="dispositivo.telefono" required :state="phoneState"
                  aria-describedby="input-live-help input-live-feedback" autocomplete="off" @input="onPhoneInput"
                  placeholder="Ej. 5512345678 o +52 55 1234 5678">
                </b-form-input>
              </b-input-group>

              <b-form-invalid-feedback id="input-live-feedback-telefono" v-if="phoneState === false">
                {{ phoneValidationMessage }}
              </b-form-invalid-feedback>

              <b-form-text v-if="estatusTelefono" style="color: red !important">
                ¡Ingrese otro número de teléfono!
              </b-form-text>
            </b-col>

          </div>

          <div class="row">
            <!--TEMPLATE SELECT GRUPO y USUARIO (ROL MASTER)-->
            <template v-if="master">

              <b-col cols="12" sm="6">
                <label for="area">{{ $t('vDispositivos.msgGrupo') }}* :</label>

                <multiselect id="area" v-model="dispositivo.area" :options="areas" :multiple="false"
                  :selectLabel="$t('vHistorico.presioneAgregar')" emptyLabel="No se encontraron elementos"
                  :selectedLabel="$t('vHistorico.seleccionado')" :deselectLabel="$t('vHistorico.presioneEliminar')"
                  :placeholder="$t('vDispositivos.msgSelecGrupo')" track-by="id" label="nombre"
                  @input="inputSelectArea">
                  <span slot="noResult">
                    {{ $t("vHistorico.msgBusquedaFallida") }}
                  </span>
                </multiselect>
              </b-col>
              <b-col cols="12" sm="6" v-if="master">
                <label for="usuarios">{{ $t('vDispositivos.msgAsigUsers') }}:</label>
                <multiselect id="usuarios" v-model="dispositivo.usuarios" :options="usuariosGrupo" :multiple="true"
                  :selectLabel="$t('vHistorico.presioneAgregar')" :selectedLabel="$t('vHistorico.seleccionado')"
                  :deselectLabel="$t('vHistorico.presioneEliminar')" :placeholder="$t('Gral.escribaBuscar')"
                  track-by="matricula" label="matricula" :class="{ 'is-invalid': usuariosState === false }">
                  <span slot="noResult">{{ this.$t('vHistorico.msgBusquedaFallida') }}</span>
                </multiselect>
                <div v-if="usuariosState === false" class="text-danger mt-1">
                  {{ usuariosValidationMessage }}
                </div>
              </b-col>

            </template>
            <!--TEMPLATE SELECT GRUPO y USUARIO (ROL ADMINISTRADORES)-->
            <template v-else>

              <b-col cols="12" sm="6">
                <label for="area1">{{ $t('vDispositivos.msgGrupo') }}* :</label>

                <multiselect id="area1" v-model="dispositivo.area" :options="areasListForUserAdministrador"
                  :multiple="false" :selectLabel="$t('vHistorico.presioneAgregar')"
                  emptyLabel="No se encontraron elementos" :selectedLabel="$t('vHistorico.seleccionado')"
                  :deselectLabel="$t('vHistorico.presioneEliminar')" :placeholder="$t('vDispositivos.msgSelecGrupo')"
                  track-by="id" label="nombre" @input="inputSelectArea">
                  <span slot="noResult">
                    {{ $t("vHistorico.msgBusquedaFallida") }}
                  </span>
                </multiselect>

              </b-col>

              <b-col cols="12" sm="6">
                <label for="usuarios">{{ $t('vDispositivos.msgAsigUsers') }}:</label>
                <multiselect v-model="dispositivo.usuarios" :options="usuariosGrupo" :multiple="true"
                  :selectLabel="$t('vHistorico.presioneAgregar')" :selectedLabel="$t('vHistorico.seleccionado')"
                  :deselectLabel="$t('vHistorico.presioneEliminar')" :placeholder="$t('Gral.escribaBuscar')"
                  track-by="matricula" label="matricula" :class="{ 'is-invalid': usuariosState === false }">
                  <span slot="noResult">{{ this.$t('vHistorico.msgBusquedaFallida') }}</span>
                </multiselect>
                <div v-if="usuariosState === false" class="text-danger mt-1">
                  {{ usuariosValidationMessage }}
                </div>
              </b-col>
            </template>

          </div>

          <b-row>
            <div class="col-12 col-sm-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 d-lg-flex justify-content-lg-end">
              <b-btn color="primary" class="mt-2 ancho-boton w-100" style="color:white;" :to="vistaAnterior">
                {{ this.$t('Gral.cancelar') }}
              </b-btn>
            </div>
            <div class="col-12 col-sm-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 sepracion-div-boton-guardar">
              <b-btn variant="info" class="mt-2 ancho-boton w-100" style="color:white;" type="submit"
                :disabled="validaciones()">
                {{ $t('vDispositivos.msgSaveDispo') }}
              </b-btn>
            </div>
          </b-row>
        </b-col>
      </b-form>
    </b-card>

    <!--GPS INSTITUCIONAL ALTERNATE (sin cambios funcionales) -->
    <b-card class="mx-auto" tile v-else>
      <span>*{{ $t('Gral.camposObligatorios') }}</span>
      <h5 class="text-center text-danger" v-if="estatusImei">El IMEI ya está registrado, ingrese otro por favor.</h5>
      <b-form @submit.stop.prevent="updateDispositivoInstitucional" style="z-index: 1;">
        <b-col cols="12" sm="12">
          <div class="row">
            <b-col cols="12" sm="12">
              <label for="nombre2">{{ $t('Gral.nombre') }}* :</label>
              <b-form-input class="form-input-border" id="nombre2" v-model="dispositivo.nombre" required
                autocomplete="off">
              </b-form-input>
              <b-form-invalid-feedback id="nombre-invalid1">
                {{ $t('vDispositivos.msgIngresarN') }}
              </b-form-invalid-feedback>
            </b-col>
          </div>
          <div class="row">
            <b-col cols="12" sm="6">
              <label for="imei2">Serial</label>
              <b-form-input id="imei2" v-model="dispositivo.serial" required :state="serialInstState"
                aria-describedby="input-live-help input-live-feedback" autocomplete="off">
              </b-form-input>
              <b-form-invalid-feedback id="input-live-feedback">
                {{ translateFormat }}
              </b-form-invalid-feedback>
              <b-form-text id="input-live-help">
                {{ $t('vDispositivos.msgFormatValido') }}
              </b-form-text>
            </b-col>
            <b-col cols="12" sm="6">
              <label for="imei3">{{ txtImei }}</label>
              <b-form-input id="imei3" v-model="dispositivo.imei" type="number" required :disabled="!isMaster"
                :state="dispositivo.imei.length === 15"
                aria-describedby="input-live-help input-live-feedback3 input-live-feedback2" autocomplete="off">
              </b-form-input>
              <b-form-invalid-feedback v-if="dispositivo.imei.length !== 15" id="input-live-feedback3">
                El IMEI debe tener 15 caracteres
              </b-form-invalid-feedback>
              <b-form-text v-if="estatusImei === true" id="input-live-feedback2" style="color: red !important;">
                ¡Ingrese un IMEI diferente!
              </b-form-text>
            </b-col>

            <!--TEMPLATE SELECT GRUPO y USUARIO (ROL MASTER)-->
            <template v-if="master">
              <!--Input Select GRUPO-->
              <b-col sm="12" md="6" lg="6">
                <label for="area2">{{ $t('vDispositivos.msgGrupo') }}* :</label>

                <multiselect id="area2" v-model="dispositivo.area" :options="areas" :multiple="false"
                  :selectLabel="$t('vHistorico.presioneAgregar')" emptyLabel="No se encontraron elementos"
                  :selectedLabel="$t('vHistorico.seleccionado')" :deselectLabel="$t('vHistorico.presioneEliminar')"
                  :placeholder="$t('vDispositivos.msgSelecGrupo')" track-by="id" label="nombre">
                  <span slot="noResult">
                    {{ $t("vHistorico.msgBusquedaFallida") }}
                  </span>
                </multiselect>

              </b-col>

              <!--Input Select USUARIOS-->
              <b-col sm="12" md="6" lg="6">
                <label for="usuarios2">{{ $t('vDispositivos.msgAsigUsers') }}:</label>
                <multiselect id="usuarios2" v-model="dispositivo.usuarios" :options="usuariosGrupo" :multiple="true"
                  :selectLabel="$t('vHistorico.presioneAgregar')" :selectedLabel="$t('vHistorico.seleccionado')"
                  :deselectLabel="$t('vHistorico.presioneEliminar')" :placeholder="$t('Gral.escribaBuscar')"
                  track-by="matricula" label="matricula" :class="{ 'is-invalid': usuariosState === false }">
                  <span slot="noResult">{{ this.$t('vHistorico.msgBusquedaFallida') }}</span>
                </multiselect>
                <div v-if="usuariosState === false" class="text-danger mt-1">
                  {{ usuariosValidationMessage }}
                </div>
              </b-col>

            </template>
            <!--TEMPLATE SELECT GRUPO y USUARIO (ROL ADMINISTRADORES)-->
            <template v-else>
              <!--Input Select GRUPO-->
              <b-col sm="12" md="6" lg="6">
                <label for="area3">{{ $t('vDispositivos.msgGrupo') }}* :</label>

                <multiselect id="area3" v-model="dispositivo.area" :options="areasListForUserAdministrador"
                  :multiple="false" :selectLabel="$t('vHistorico.presioneAgregar')"
                  emptyLabel="No se encontraron elementos" :selectedLabel="$t('vHistorico.seleccionado')"
                  :deselectLabel="$t('vHistorico.presioneEliminar')" :placeholder="$t('vDispositivos.msgSelecGrupo')"
                  track-by="id" label="nombre">
                  <span slot="noResult">
                    {{ $t("vHistorico.msgBusquedaFallida") }}
                  </span>
                </multiselect>

              </b-col>

              <!--Input select usuario -->
              <b-col sm="12" md="6" lg="6" class="mb-3">
                <label for="usuarios">{{ $t('vDispositivos.msgAsigUsers') }}:</label>
                <multiselect v-model="dispositivo.usuarios" :options="usuariosGrupo" :multiple="true"
                  :selectLabel="$t('vHistorico.presioneAgregar')" :selectedLabel="$t('vHistorico.seleccionado')"
                  :deselectLabel="$t('vHistorico.presioneEliminar')" :placeholder="$t('Gral.escribaBuscar')"
                  track-by="matricula" label="matricula" :class="{ 'is-invalid': usuariosState === false }">
                  <span slot="noResult">{{ this.$t('vHistorico.msgBusquedaFallida') }}</span>
                </multiselect>
                <div v-if="usuariosState === false" class="text-danger mt-1">
                  {{ usuariosValidationMessage }}
                </div>
              </b-col>
            </template>

          </div>

          <b-row>
            <div class="col-12 col-sm-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 d-lg-flex justify-content-lg-end">
              <b-btn color="primary" class="ancho-boton w-100" style="color:white;" :to="vistaAnterior">
                {{ this.$t('Gral.cancelar') }}
              </b-btn>
            </div>
            <div class="col-12 col-sm-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 sepracion-div-boton-guardar">
              <b-btn variant="info" class="ancho-boton w-100" style="color:white;" type="submit"
                :disabled="validacionesDispoInst()">
                {{ $t('vDispositivos.msgSaveDispo') }}
              </b-btn>
            </div>
          </b-row>
        </b-col>
      </b-form>
    </b-card>
  </b-col>
</template>

<script src="js/main.js"></script>
<script>
import UsersDataService from '../../../services/UsersDataService';
import DevicesDataService from "@/services/DevicesDataService";
import AreaDataService from "@/services/AreaDataService";
import AccionesDataService from "../../../services/AccionesDataService";
import Multiselect from 'vue-multiselect';
import * as Utils from "../../../utils/Utils"
import ModelosDataService from "../../../services/ModelosDataService";
import { verificarAcceso } from '../../../utils/Session';
import Crypto from '../../../services/Crypto';
import countries from "../../../utils/countries.json";

export default {
  name: 'edit_Dispositivo',
  components: { Multiselect },
  data(){
    return {
      gpsModelList: [],
      selectedModel: null,
      txtImei: null,
      txtFormato: null,
      expresion: "^\\d{-1}$",
      filtro: null,
      vistaAnterior: "",
      dispositivo:{
        id: 0,
        nombre: "",
        contrasena: "",
        imei: "",
        modelo: "",
        telefono: "",
        usuarios: [],
        area: null,
        compartirLink: false,
        compartirHasta: 0,
        tipo: "",
        serial: "",
        iso: null // será usado para preseleccionar país si existe
      },
      usuariosGrupo: [],
      selected: [],
      usuariosTodos: [],
      submitted: false,
      areas: [],
      areasListForUserAdministrador: [],
      master: false,
      idMaster: process.env.VUE_APP_ID_MASTER,
      accion: '',
      usuarioLogueado: JSON.parse(sessionStorage.getItem('usuarioLogueado')),

      isGenericGPS: false,
      key: "",
      tipo : false,
      auxImei: null,
      options: [
        { text: 'comercial', value: '2', disabled: true  },
        { text: 'institucional', value: '1' , disabled: true },
      ], 

      tipoDispositivo: null,
      estatusImei: false,
      estatusTelefono: false,

      selectedPaisId: "",

      // ejemplo
      exampleMap: {
        MX: "+52 55 1234 5678",
        CO: "+57 300 123 4567",
        AR: "+54 9 11 1234 5678",
        US: "+1 555 123 4567",
        CA: "+1 416 123 4567",
        PE: "+51 9 123 456 78",
      },
      // regex map por país
      regexMap: {
        AR: /^(?:\+54)?\d{10}$/,                
        BO: /^(?:\+591)?\d{8}$/,               
        BR: /^(?:\+55)?\d{10,11}$/,            
        CL: /^(?:\+56)?\d{8,9}$/,              
        CO: /^(?:\+57)?\d{10}$/,               
        CR: /^(?:\+506)?\d{8}$/,               
        CU: /^(?:\+53)?\d{8}$/,                
        DO: /^(?:\+1)?\d{10}$/,                
        EC: /^(?:\+593)?\d{9}$/,               
        SV: /^(?:\+503)?\d{8}$/,               
        GT: /^(?:\+502)?\d{8}$/,               
        HN: /^(?:\+504)?\d{8}$/,               
        MX: /^(?:\+52)?\d{10}$/,               
        NI: /^(?:\+505)?\d{8}$/,               
        PA: /^(?:\+507)?\d{8}$/,               
        PY: /^(?:\+595)?\d{8,9}$/,             
        PE: /^(?:\+51)?\d{9}$/,                
        PR: /^(?:\+1)?\d{10}$/,                
        UY: /^(?:\+598)?\d{8,9}$/,             
        VE: /^(?:\+58)?\d{10}$/,               
        CA: /^(?:\+1)?\d{10}$/,                
        US: /^(?:\+1)?\d{10}$/                 
      },
      phoneValidationMessage: '',

      cargandoDispositivo: true,
      areaInicialAsignada: false,
    };
  },
  beforeCreate(){
    verificarAcceso();

    if(!sessionStorage.getItem('rol') ||  sessionStorage.idRol === process.env.VUE_APP_ID_USUARIO_FINAL){
      this.$router.push({
        path: "/monitoreo"
      });
      const Toast = this.$swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 4000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', this.$swal.stopTimer)
          toast.addEventListener('mouseleave', this.$swal.resumeTimer)
        }
      });

      Toast.fire({
        icon: 'error',
        title: this.$t('vDispositivos.noPermisos'),
      });
    }
  },
  async mounted() {
    this.key = sessionStorage.getItem('key');

    const datos = this.$route.params;

    this.tipo = datos.tipo !== "Institucional";

    await Promise.all([
        this.obtenerModelos(),
        this.obtenerAreas(),
        this.obtenerUsuarios(),
        this.obtenerAreasPorUserAdministrativo()
    ]);

    this.mostrarDispositivo(datos);
},
  computed: {
    translateFormat(){
      if(this.txtFormato === "IMEI") return this.$t("vDispositivos.msgImei");
      if(this.txtFormato === "ID") return this.$t("vDispositivos.msgId");
    },
    imeiState() {
      return this.dispositivo.imei.match(this.expresion)  ? true : false
    },

    // phone validation computed: null | true | false
    phoneState() {
      const raw = (this.dispositivo.telefono || '').trim();
      if (!raw) {
        this.phoneValidationMessage = '';
        return null;
      }
      const norm = this._normalizeInput(raw);
      const iso = this.selectedPaisId || 'MX';
      const regex = this.regexMap[iso];
      if (!regex) {
        const onlyDigits = norm.replace(/^\+/, '').replace(/\D/g, '');
        if (onlyDigits.length < 6 || onlyDigits.length > 15) {
          this.phoneValidationMessage = this.$t('vConfiguraciones.msgNumero') || 'Longitud inválida';
          return false;
        }
        this.phoneValidationMessage = '';
        return true;
      }
      const ok = regex.test(norm);
      this.phoneValidationMessage = ok ? '' : (this.$t('vConfiguraciones.msgNumero') || `Número inválido para ${iso}`);
      return ok;
    },

    phoneValidationMessageComputed() {
      return this.phoneValidationMessage || '';
    },

    passwordState(){
      return this.dispositivo.contrasena.match("^\\d{6}$")  ? true : false
    },
    modelState(){
      return this.selectedModel ? true : false
    },

    imeiInstState(){
      return this.dispositivo.imei.length === 15 && this.dispositivo.imei.trim() !== '' ? true : false;
    },
    
    serialInstState(){
      return this.dispositivo.serial.length === 9 && this.dispositivo.serial.trim() !== '' ? true : false;
    },

    isMaster(){
      return sessionStorage.getItem('idRol') === process.env.VUE_APP_ID_MASTER
    },

    translateRadio() {
      return this.options.map(el => {
          return {
            ...el,
            text: this.$t(`tableHeaders.${el.text}`)
          };
      });
    },

    // select country options from countries.json
    countryOptions() {
      return countries.map(c => ({
        iso: c.iso,
        label: `${c.bandera} ${c.paisNombre} (${c.dialCode})`,
        dialCode: c.dialCode,
        bandera: c.bandera,
        paisNombre: c.paisNombre
      }));
    },

    selectedCountry() {
      return countries.find(c => c.iso === this.selectedPaisId.iso) || null;
    },

    selectedDialCode() {
      const c = countries.find((country) => country.iso === this.selectedPaisId.iso);
      return c ? c.dialCode : "";
    },

    grupoState() {
      // no mostrar error hasta que el usuario interactúe
      if (this.dispositivo.area === null || this.dispositivo.area === undefined) {
        return null;
      }
      return true;
    },

    usuariosState() {
      // MASTER no requiere usuarios
      if (this.isMaster) return true;

      const users = this.dispositivo.usuarios;

      if (!users || users.length === 0) {
        return false;
      }

      return true;
    },

    usuariosValidationMessage() {
      if (this.isMaster) return '';
      if (!this.dispositivo.usuarios || this.dispositivo.usuarios.length === 0) {
        return this.$t('vDispositivos.msgAsigUsers');
      }
      return '';
    },

    

  },
  watch:{
      isGenericGPS(value){
        if(value){
          this.expresion = "^\\d{10}(?:\\d{5})?$";
        }
      },

      'dispositivo.area'(newVal, oldVal) {

        // ignorar la primera asignación (null → valor)
        if (!this.areaInicialAsignada) {
          this.areaInicialAsignada = true;
          return;
        }

        // si no hay cambio real
        if (newVal === oldVal) return;

        // cambio manual real
        this.dispositivo.usuarios = [];
        this.usuariosGrupo = [];

        this.cargarUsuariosPorArea(newVal.id);
      },
    },
  methods:{
    limpiarTexto(texto) {
      return texto.split('*')[0].trim();
    },

    contarDigitos(){
      if(this.isGenericGPS){
        this.expresion = "^\\d{10}(?:\\d{5})?$";
        if(this.dispositivo.imei.length <10){
          this.txtImei = "ID*: ";
          this.txtFormato = "ID";
        }
        if(this.dispositivo.imei.length >10 && this.dispositivo.imei.length<15){
          this.txtImei = "IMEI*: ";
          this.txtFormato = "IMEI";
        }
      }
    },

    /**
     * Método encargado de obtener los modelos de gps registrados en bd
     */
    async obtenerModelos() {
      try{
        const response = await ModelosDataService.getAllHabilitados();
        const decoded = await Crypto.desencriptar(response.data, this.key);
        this.gpsModelList = decoded;
      }catch(error){
      }
    },

    mostrarDispositivo(datos){
      
      
      if (!datos || datos.imei == null) {
        if (
          datos?.vistaAnterior &&
          this.$route.path !== datos.vistaAnterior
        ) {
          this.$router.push({ path: datos.vistaAnterior });
        }
        return;
      }

      // cargar datos en el formulario
      this.dispositivo.id = datos.id;
      this.dispositivo.nombre = datos.nombre;
      this.dispositivo.contrasena = datos.contrasena;
      this.dispositivo.imei = datos.imei;
      this.dispositivo.telefono = datos.telefono || '';
      this.dispositivo.usuarios = datos.usuarios;
      this.dispositivo.modelo = datos.modelo;
      this.selectedModel = datos.modeloGps == null ? null : datos.modeloGps;
      this.dispositivo.compartirHasta = datos.compartirHasta;
      this.dispositivo.compartirLink = datos.compartirLink;
      this.dispositivo.serial = datos.serial;
      this.dispositivo.tipo = datos.tipo;
      this.dispositivo.area = datos.area == null ? null : (datos.area || datos.area);

      this.tipoDispositivo = this.dispositivo.tipo === "Institucional" ? '1' : '2';
      this.vistaAnterior = datos.vistaAnterior;

      

      // preseleccionar país si llega la iso en datos (mantener MX si no)
      const isoABuscar = datos.iso || this.dispositivo.iso || 'MX';

      // Buscamos el objeto completo en nuestra lista para tener la bandera y el formato
      const paisEncontrado = this.countryOptions.find(opt => opt.iso === isoABuscar);

      if (paisEncontrado) {
        this.selectedPaisId = paisEncontrado;
      } else {
        // Caso de respaldo: si no está en la lista (ej. datos externos), crear objeto básico
        this.selectedPaisId = {
          iso: isoABuscar,
          dialCode: isoABuscar === 'MX' ? '+52' : '', // Puedes ajustar según tus necesidades
          label: isoABuscar
        };
      }

      // establecer txtImei/expresion de acuerdo al imei existente
      if(this.selectedModel == null){
        if(this.dispositivo.imei.length == 10){
          this.txtImei = "ID* :";
          this.expresion = "^\\d{10}$";
        }
        else if(this.dispositivo.imei.length == 15){
          this.txtImei = "IMEI* :";
          this.expresion = "^\\d{15}$";
        }

        if(datos.tipo === "Comercial"){
          Utils.generalSweetAlert( this.$t('vDispositivos.msgNoDispositivoModelo'), "warning");
        }

      }else{
        if(this.dispositivo.imei.length == 10){
          this.txtImei = "ID* :";
          this.expresion = "^\\d{10}$";
        }
        else if(this.dispositivo.imei.length == 15){
          this.txtImei = "IMEI* :";
          this.expresion = "^\\d{15}$";
        }
      }

      // cargar usuarios iniciales
      if (this.dispositivo.area) {
        this.cargarUsuariosPorArea(this.dispositivo.area.id);
      }

      // ahora sí terminó la carga
      this.cargandoDispositivo = false;
    },

    /*cargarUsuariosPorArea(areaId) {
      
      this.usuariosGrupo = [];

      this.usuariosTodos.forEach((value) => {
        if (
          value.area &&
          value.area.id === areaId &&
          value.rol.id == process.env.VUE_APP_ID_USUARIO_FINAL
        ) {
          this.usuariosGrupo.push(value);
        }
      });
    },*/

    cargarUsuariosPorArea(areaId) {

    this.usuariosGrupo = this.usuariosTodos.filter(usuario =>
        usuario.area &&
        String(usuario.area.id) === String(areaId) &&
        usuario.rol &&
        String(usuario.rol.id) ===
            String(process.env.VUE_APP_ID_USUARIO_FINAL)
    );
},

    async updateDispositivoInstitucional(){
      const data = {
        id: this.dispositivo.id,
        nombre: this.dispositivo.nombre,
        contrasena: this.dispositivo.contrasena,
        modelo: this.dispositivo.modelo, //Marca
        model: this.gpsModelList.find((item) => item.id === this.selectedModel),
        telefono: "No asignado",
        imei: this.dispositivo.imei,
        usuarios: this.dispositivo.usuarios,
        area: this.areas.find(item => item.id === this.dispositivo.area.id),
        compartirLink: this.dispositivo.compartirLink,
        compartirHasta: this.dispositivo.compartirHasta,
        tipo: "Institucional",
        serial: this.dispositivo.serial
      };
      
      try {
        const response = await DevicesDataService.update(data, this.key)
        if(response.status === 200){

          this.accion = 'Actualizó el dispositivo ' + data.nombre + ' con IMEI ' + data.imei;
          this.registrarAccion();

          const Toast = this.$swal.mixin({
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener('mouseenter', this.$swal.stopTimer)
                toast.addEventListener('mouseleave', this.$swal.resumeTimer)
              }
            })

            Toast.fire({
              icon: 'success',
              title: this.$t('vDispositivos.msgDeviceUpdate')
            });
            this.$router.push({ path: this.vistaAnterior});
        }
      } catch (e) {
        if(e.response.data = "imei existe"){
          this.estatusImei = true
        }
        console.log('error', e.response);
      }
    },

    updateDispositivo(){
      let data = {
          id: this.dispositivo.id,
          nombre: this.dispositivo.nombre,
          contrasena: this.dispositivo.contrasena,
          modelo: this.dispositivo.modelo, //Marca
          model: this.gpsModelList.find((item) => item.id === this.selectedModel.id),
          telefono: this.dispositivo.telefono,
          imei: this.dispositivo.imei,
          usuarios: this.dispositivo.usuarios,
          area: this.areas.find(item => item.id === this.dispositivo.area.id),
          compartirLink: this.dispositivo.compartirLink,
          compartirHasta: this.dispositivo.compartirHasta,
          tipo: "Comercial",
          serial: "",
          iso: this.selectedCountry.iso,
          paisNombre: this.selectedCountry.paisNombre,
          dialCode: this.selectedCountry.dialCode
      };
      

      let txt = "IMEI"; //Texto para concatenar con el dato IMEI/Id
      switch (data.modelo) {
        case "TKSTAR":
          txt = "Id"
          break;
        case "TK108":
          txt = "IMEI"
          break;
        default:
          txt = this.txtFormato == "ID" ? "Id" : "IMEI";
      }
      DevicesDataService.update(data, this.key)
          .then(() => {
            this.accion = 'Actualizó el dispositivo: ' + data.nombre + ' con ' + txt + ': ' + data.imei;
            this.registrarAccion();
            const Toast = this.$swal.mixin({
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener('mouseenter', this.$swal.stopTimer)
                toast.addEventListener('mouseleave', this.$swal.resumeTimer)
              }
            })

            Toast.fire({
              icon: 'success',
              title: this.$t('vDispositivos.msgDeviceUpdate')
            });
            this.$router.push({ path: this.vistaAnterior});
          })
          .catch(e => {
            console.error("Erro al actualizar el gps:: ",e)
            if (e.response.data === "imei existe") {
              this.estatusImei = true;
            }

            if (e.response.data === "telefono existe") {
              this.estatusTelefono = true;
            }

            if (e.response.data === "imei y telefono existen") {
              this.estatusTelefono = true;
              this.estatusImei = true;
            }

          });
    },

    continuar(){
      this.submitted = false;
    },


    async obtenerUsuarios() {
    try {
        const response = await UsersDataService.getAll();

        this.usuariosTodos = await Crypto.desencriptar(
            response.data,
            this.key
        );


    } catch (error) {
        console.error("Error al obtener usuarios:", error);
    }
},
    
    obtenerAreas(){
      AreaDataService.getHabilitados()
        .then(async (response) => {
          this.areas = await Crypto.desencriptar(response.data, this.key);
          /*if(sessionStorage.idRol == process.env.VUE_APP_ID_MASTER){
            this.master = true;
          }*/
         this.master = this.esUsuarioMaster();
        });
    },

    /**
     * obtenerAreas
     * Metodo que obtiene las areas asignadas a un usario administrativo
     * @autor DPA
     */
    async obtenerAreasPorUserAdministrativo() {
      
      const usuarioFiltroString = sessionStorage.getItem('usuarioFiltro');

      const estado =(usuarioFiltroString === null || usuarioFiltroString === '' || usuarioFiltroString === 'null') ? 'VACIO' : 'CON VALOR';

      let id_user;

      if (estado === 'CON VALOR') {
        const isUserFiltrado = JSON.parse(usuarioFiltroString);
        id_user = isUserFiltrado.id;
      } else {
        id_user = sessionStorage.getItem('id_user');
      }

      try {
        const response = await AreaDataService.getAreasPorAdministrador(id_user,this.key);

        this.areasListForUserAdministrador = await Crypto.desencriptar(response.data, this.key);
        this.master = this.esUsuarioMaster();

      } catch (error) {
        console.error('Error al obtener áreas por administrador:', error);
      }
    },

    inputSelectArea() {

      // ⚠️ selectedArea no se usa en el v-model
      // this.$emit("input", ... ) → innecesario aquí

      this.usuariosGrupo = [];

    
      if (!this.cargandoDispositivo) {
        this.dispositivo.usuarios = [];
      }
      
      
      this.usuariosTodos.forEach((value) => {
        if (
          value.area && value.area.id === this.dispositivo.area.id &&
          value.rol.id == process.env.VUE_APP_ID_USUARIO_FINAL
        ) {
          this.usuariosGrupo.push(value);
        }
      });
    },

    // ----- COUNTRY / PHONE HELPERS -----
    inputSelectPais(val) {
      this.selectedPaisId = val;
      // revalidar número existente
      const v = this.dispositivo.telefono || "";
      const res = this.isPhoneValidByRegex(v, val);
      this.phoneValidationMessage = res.message;
    },

    _normalizeInput(raw) {
      if (!raw && raw !== "") return "";
      let v = String(raw);
      v = v.replace(/[\s\-\.\(\)]/g, "");
      const pluses = (v.match(/\+/g) || []).length;
      if (pluses > 1) {
        v = v.replace(/\+/g, (m, offset) => (offset === v.indexOf("+") ? "+" : ""));
      }
      return v;
    },

    isPhoneValidByRegex(raw, iso = null) {
      const norm = this._normalizeInput(raw);
      if (!norm) return { valid: null, message: "" };

      const countryIso = iso || this.selectedPaisId.iso || "MX";
      const regex = this.regexMap[countryIso];

      if (!regex) {
        const onlyDigits = norm.replace(/\D/g, "");
        if (onlyDigits.length < 6 || onlyDigits.length > 15) {
          return { valid: false, message: this.$t('vConfiguraciones.msgNumero') || 'Longitud inválida' };
        }
        return { valid: true, message: "" };
      }

      const ok = regex.test(norm);
      return {
        valid: ok,
        message: ok ? "" : (this.$t('vConfiguraciones.msgNumero') || `Número inválido para ${countryIso}`),
      };
    },

    onPhoneInput() {
      let v = this.dispositivo.telefono || "";
      // permitir + solo al inicio y dígitos
      v = v.replace(/[^\d+]/g, "");
      const firstPlus = v.indexOf("+");
      if (firstPlus > 0) {
        v = "+" + v.replace(/\+/g, "");
      } else if (firstPlus === -1) {
        v = v.replace(/\+/g, "");
      } else {
        v = "+" + v.slice(1).replace(/\+/g, "");
      }
      this.dispositivo.telefono = v;

      // validar y actualizar mensaje
      const res = this.isPhoneValidByRegex(v, this.selectedPaisId);
      this.phoneValidationMessage = res.message;
      // phoneState computed re-evalúa automáticamente
    },

    validaciones(){
      return !(this.imeiState && this.phoneState && this.passwordState && this.selectedModel && this.grupoState === true && this.usuariosState === true);
    },
    validacionesDispoInst() {
      return (!this.imeiInstState || !this.serialInstState || !this.grupoState || !this.usuariosState);
    },

    registrarAccion(){   
        var data = {
        usuario: this.usuarioLogueado,
        accion: this.accion + sessionStorage.infoDevice,
        fechaCreacion: new Date(),
        tipo: 'accion',
        };
        AccionesDataService.create(data, this.key); 
    },

    modeloSelected() { //dependiendo del modelo seleccionado, se cambiara el campo imei/id de forma dinamica
      let modeloDecoder = "";
      modeloDecoder = this.gpsModelList.find((item) => item.id === this.selectedModel.id);

      if(modeloDecoder.marca.marca == "COBAN")
        this.dispositivo.modelo = "TK108";
      else this.dispositivo.modelo = modeloDecoder.marca.marca;

      this.$emit("input", (this.filtro = this.dispositivo.modelo));
      //dependiendo del modelo seleccionado, se cambiará la cabecera del campo a ID o IMEI, asi como la expresion regular que valida el largo del campo
      switch (this.filtro) {
        case "TKSTAR":
          this.txtImei = "ID* :";
          this.txtFormato = "ID";
          this.expresion = "^\\d{10}$";
          this.isGenericGPS = false;
          break;

        case "TK108":
        case "Concox":
          this.txtImei = "IMEI* :";
          this.txtFormato = "IMEI";
          this.expresion = "^\\d{15}$";
          this.isGenericGPS = false;
          break;

        default: //Si la marca es "Generica"
          this.isGenericGPS = true;
      }
    },

    esUsuarioMaster() {
      
        const isUserFiltradoString = sessionStorage.getItem("usuarioFiltro");
      
        if (isUserFiltradoString != 'null' && isUserFiltradoString != '' && isUserFiltradoString != null) {
            //Es un usuario master que accedio a vista de Administrador
            try {
                const isUserFiltrado = JSON.parse(isUserFiltradoString);

                if (isUserFiltrado.rol.id === "6081c4becaae9b0d5e87e61b") {
                    return false;
                }
            } catch (e) {
                console.error("Error al parsear usuarioFiltro:", e);
                return true;
            }
        } else {
          if (sessionStorage.idRol === "6081c4becaae9b0d5e87e61b") {
            // Es usuario administrador
            return false;
          }else if (sessionStorage.idRol == process.env.VUE_APP_ID_MASTER) {
            // 4. Comprobación final del rol Master (basado en el usuario logueado)
            return true;
          }
        }

        // Si ninguna condición se cumple, por defecto devolvemos false (si no es Master y si el filtro no era el especificado)
        return true;
    },
    
  },//END Methods
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
small {
  font-size: 85%;
}

.submit-form {
  max-width: 400px;
}

.multiselect__tag {
  background: #0e7db9;
}

@media (max-width: 600px) {
  .card {
    margin-top: 10px !important;
  }
}

@media (max-width: 768px) {
  .btnVolver {
    position: absolute;
    top: -40px;
    left: 16px;
  }
}

@media (min-width: 769px) {
  .btnVolver {
    display: none !important;
  }
}

@media (max-width: 959px) {
  .sepracion-div-boton-guardar {
    margin-top: -12px
  }
}

@media (min-width: 960px) {
  .sepracion-div-boton-guardar {
    margin-top: 0px
  }
}

@media (min-width: 992px) {
  .ancho-boton {
    width: 300px;
  }
}

@media (min-width: 2560px) {

  /* 1. Contenedor y Título */
  .d-flex.mt-2 {
    align-items: center !important;
    gap: 2rem !important;
  }

  .d-flex.mt-2 p {
    font-size: 2.2rem !important;
    /* Un poco más grande para legibilidad */
    margin-right: 2rem !important;
    margin-bottom: 0 !important;
  }

  /* 2. Opciones de Radio */
  .custom-control.custom-radio {
    display: inline-flex !important;
    align-items: center !important;
    margin-right: 6rem !important;
    padding-left: 0 !important;
    /* Limpieza total */
    position: relative !important;
    min-width: 200px !important;
  }

  /* 3. El Círculo Base (Fondo Azul/Gris) */
  .custom-control-input~.custom-control-label::before {
    content: "" !important;
    display: block !important;
    position: absolute !important;
    left: 0 !important;
    /* Forzamos posición 0 */
    top: 50% !important;
    transform: translateY(-50%) !important;
    width: 3.5rem !important;
    height: 3.5rem !important;
    margin: 0 !important;
    /* Eliminamos cualquier margen que lo empuje */
    background-color: #f8f9fa !important;
    border: 2px solid #adb5bd !important;
    border-radius: 50% !important;
    box-shadow: none !important;
  }



  /* 4. El Punto Blanco (Capa Superior) */
  .custom-control-input~.custom-control-label::after {
    content: "" !important;
    display: block !important;
    position: absolute !important;
    /* Centrado manual: (3.5 / 2) - (1.2 / 2) = 1.15rem */
    left: 1.15rem !important;
    top: 50% !important;
    transform: translateY(-50%) !important;
    width: 1.2rem !important;
    height: 1.2rem !important;
    margin: 0 !important;
    background-image: none !important;
    border-radius: 50% !important;
  }

  /* Color cuando está seleccionado */
  .custom-control-input:checked~.custom-control-label::before {
    background-color: #4466f2 !important;
    border-color: #4466f2 !important;
  }

  /* Mostrar punto blanco solo al marcar */
  .custom-control-input:checked~.custom-control-label::after {
    background-color: white !important;
  }

  /* 5. Texto de la etiqueta (Separación total) */
  .inputRadioGroup {
    margin-right: 4rem !important;
  }
}
</style>
